module.exports = __webpack_public_path__ + "img/5.6271b0a7.png";